import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import FolderSharedOutlinedIcon from '@mui/icons-material/FolderSharedOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';

const seg = {
  root: 'engagement-letters',
  home: '',
  client: 'client',
  clientId: ':clientId',
  waiver: 'waiver',
  waiverId: ':waiverId',
} as const;

export const engagementLetterDatabaseRoutes = {
  segment: seg.root,
  path: `/${seg.root}`,
  label: 'Engagement Letter Database',
  icon: DescriptionOutlinedIcon,
  isPortalApp: true,
  home: {
    segment: seg.home,
    path: `/${seg.root}`,
    label: 'Home',
    icon: HomeOutlinedIcon,
  },
  client: {
    segment: `${seg.client}/${seg.clientId}`,
    path: `/${seg.root}/${seg.client}/${seg.clientId}`,
    label: 'Client',
    icon: FolderSharedOutlinedIcon,
  },
  waiver: {
    segment: `${seg.waiver}/${seg.waiverId}`,
    path: `/${seg.root}/${seg.waiver}/${seg.waiverId}`,
    label: 'Waiver',
    icon: FolderSharedOutlinedIcon,
  },
};

export type EngagementLetterDatabaseRoutes = typeof engagementLetterDatabaseRoutes;
